export const saturdayUppercase = "lra";
export default {saturdayUppercase};